module.exports = __webpack_public_path__ + "static/media/montserrat-light-webfont.6225f3ca.woff";